import {Box, Chip} from "@mui/material";

const ParticipantList = ({participants, handleRemove}) => (
	<Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, py: 1 }}>
		{participants.map((participant, key) => (
			<Chip
				key={key}
				label={participant.firstName + " " + participant.lastName}
				onDelete={() => handleRemove && handleRemove(participant)}
				onMouseDown={(event) => {
					event.stopPropagation();
				}}
			/>
		))}
	</Box>
);
export default ParticipantList;
